<template>
    <i class="pi pi-star-fill" v-for="index in intValue" :key="index"></i>
    <i class="pi pi-star-half-fill" v-if="isHalf"></i>
</template>
<script>
 export default {
    name:"DatatableRating",
    props: {
        rating : {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isHalf: false,
            intValue: 0,
        }
    },
     mounted() {
        this.intValue = Math.floor(this.rating);
        this.isHalf = this.rating - this.intValue > 0;
    },
 }
</script>